import { render } from "./budgets-expense-modal.vue?vue&type=template&id=7ba9230e"
import script from "./budgets-expense-modal.vue?vue&type=script&lang=js"
export * from "./budgets-expense-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__